import { render } from "./ExpandableCard.vue?vue&type=template&id=93afb876&scoped=true"
import script from "./ExpandableCard.vue?vue&type=script&lang=js"
export * from "./ExpandableCard.vue?vue&type=script&lang=js"

import "./ExpandableCard.vue?vue&type=style&index=0&id=93afb876&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93afb876"]])

export default __exports__